import { useMemo } from 'react';
import { findUnknownPlaceholders } from '../utils/placeholders';
import { useDocumentVariablesQuery } from './useDocumentVariablesQuery';

export function useUnknownPlaceholders(bodyHtml: string): string[] | null {
  const variables = useDocumentVariablesQuery();
  return useMemo(
    () => (variables.data ? findUnknownPlaceholders(bodyHtml, variables.data.map((v) => v.key)) : null),
    [variables.data, bodyHtml],
  );
}
